import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
	ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { getEntityIntials } from '@core/util/client';
import { ICON } from '@core/util/icon';
import { Client } from '@models/clients';
import { LawFirm } from '@models/lawFirms';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
	selector: 'app-contact-name-badge',
	templateUrl: './contact-name-badge.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ContactNameBadgeComponent implements OnInit {
	contact$ = new ReplaySubject<Client>();

	initials$!: Observable<string>;

	@ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

	@Input() set contact(contact: Client) {
		this.contact$.next(contact);
	}

	@Input() lawFirm!: LawFirm;

	@Input() heading!: string;

	menuOpened$ = new BehaviorSubject(false);

	ICON = ICON;

	ngOnInit(): void {
		this.initials$ = this.contact$.pipe(
			filter((contact) => !!contact),
			map((contact) => getEntityIntials(contact)),
		);
	}

	onMenuOpen(): void {
		this.menuOpened$.next(true);
	}
	onMenuClose(): void {
		this.menuOpened$.next(false);
	}
}
